import type { IconProps } from "./types";

export function Zap({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
      ? color
      : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.0941 0.327926C9.3485 0.0191518 9.77626 -0.0848546 10.1439 0.0730433C10.5117 0.231039 10.731 0.613262 10.682 1.01054L9.91832 7.2H16.8998C17.2478 7.2 17.5645 7.40097 17.7132 7.71562C17.8618 8.03033 17.816 8.40284 17.5951 8.67168L8.70543 19.4725C8.45102 19.7812 8.02326 19.8852 7.65562 19.7273C7.28782 19.5693 7.06849 19.1871 7.11754 18.7898L7.88121 12.6004H0.899762C0.551698 12.6004 0.235034 12.3994 0.0862858 12.0848C-0.0622897 11.7701 -0.0165073 11.3975 0.20445 11.1287L9.0941 0.327926ZM2.80601 10.8006H8.89976C9.15764 10.8006 9.40276 10.9111 9.57359 11.1043C9.74439 11.2975 9.82487 11.5544 9.79332 11.8103L9.28257 15.9363L14.9935 8.9998H8.89976C8.64189 8.9998 8.39676 8.88926 8.22593 8.69609C8.05514 8.50291 7.97466 8.24595 8.00621 7.99004L8.51597 3.86308L2.80601 10.8006Z"
        fill={currentColor}
        transform="translate(3.1 2.1)"
      />
    </svg>
  );
}
